import React, { Component } from 'react'
import { func, object } from 'prop-types'
import { translate } from 'react-i18next'
import { initialization, stores, view } from '../../stores'
import { Loader } from '../../components/ui/states/Loader'
import { Banned } from '../../components/ui/states/Banned'
import { withRouter } from 'react-router'
import { PagesPaths } from '../../constants/Pages'
import { InquiryPathVersions } from '../../stores/inquiry'
import { getAttribution } from '../../utilities/attribution'

class InquirySubmitPageComponent extends Component {
  async componentDidMount () {
    const { history } = this.props
    await initialization
    // If inquiry is not at the final step - return to account
    if (
      (stores.inquiry.step !== 3 && stores.inquiry.pathVersion === InquiryPathVersions.V1) ||
      (stores.inquiry.step !== 5 && stores.inquiry.pathVersion === InquiryPathVersions.V2)
    ) { return history.replace(PagesPaths.ACCOUNT.path) }
    // If not active (like banned) - let the Banned displayed
    if (!stores.account.isActive()) { return }

    const inquiry = await stores.inquiry.submit({
      leadFunnel: stores.search.search.entryFunnel || null,
      attribution: getAttribution()
    })
    // Cleaning search & inquiry data
    const pathVersion = stores.inquiry.pathVersion
    stores.inquiry.clear()
    stores.search.deselectAll()
    stores.search.setEntryFunnel(null)
    stores.inquiry.setAccount({ account: stores.account.connected })

    history.replace(`${PagesPaths.INQUIRY_CREATED.path}/${inquiry.id}?path-version=${pathVersion}`)
  }

  render () {
    const { t } = this.props
    if (!stores.account.isActive()) {
      return (<Banned />)
    }

    return (
      <div>
        <Loader style={{ marginTop: '5em' }} />
        <p className='paragraph--centered'>{t('common:demande:creating')}</p>
      </div>
    )
  }
}

InquirySubmitPageComponent.propTypes = {
  t: func,
  history: object
}

export const InquirySubmitPage = withRouter(translate()(view(InquirySubmitPageComponent)))



// WEBPACK FOOTER //
// ./src/pages/demande/InquirySubmitPage.js